<div class="form-info" [class.mobile]="isMobileDevice">
	<h3 class="form-name" *ngIf="dlFormInfo?.digitalLogFormName">
		{{dlFormInfo.digitalLogFormName}}
	</h3>
	<div *ngIf="dlFormInfo.siteName">
		<span>Site:</span>
		<h3>{{dlFormInfo.siteName}}</h3>
	</div>
	<div *ngIf="dlFormInfo.assetName">
		<span>Asset:</span>
		<h3>{{dlFormInfo.assetName}}</h3>
	</div>
</div>
<ng-container *ngIf="dlFormInfo?.groups?.length == 0 || !dlFormInfo.groups">
	<div class="no-content">
		<p>
			No documents available!
		</p>
	</div>
</ng-container>
<mat-sidenav-container>
	<mat-sidenav #sidenav mode="side" position="end">
		<app-document-viewer (close)="toggleSlide()" [documentDetails]="selectedDocumentDetails"
			[isCloseDisabled]="true"></app-document-viewer>
	</mat-sidenav>

	<mat-sidenav-content [class.opened]="isOpened">
		<div class="documents-list">
			<ul>
				<li *ngFor="let group of dlFormInfo?.groups">
					<h5>
						{{group?.groupName}}
					</h5>
					<ul>
						<li *ngFor="let value of group?.timeslots">
							<h5>{{moment.parseZone(value?.timeSlotDate).format('MM/DD/YYYY')}}</h5>
							<mat-nav-list>
								<ng-container *ngIf="value?.documents?.length > 0">
									<mat-list-item (click)="showDocument(doc.documentId, doc.fileName)"
										*ngFor="let doc of value.documents"
										[class.selected]="isOpened && selectedDocumentDetails?.documentId === doc.documentId">
										<div matListAvatar *ngIf="!doc.thumbnailBase64; else imgThumbnail"
											[class]="getDocIcon(doc)"></div>
										<ng-template #imgThumbnail>
											<img class="image-thumbnail" [src]="getImageThumnail(doc)" />
										</ng-template>
	
										<h3 matLine>{{doc.fieldName}}</h3>
										<h3 matLine>{{doc.description}}</h3>
	
										<!-- <p matLine>
											<span style="text-align: right; float: right; color: lightgray;">
												{{moment.parseZone(doc.createdOn).format('MM/DD/YYYY')}} </span>
										</p> -->
	
										<div class="document-actions">
											<button mat-icon-button color="primary"
												(click)="downloadFile(doc.documentId, doc.fileName)"
												aria-label="Download document" title="Download">
												<mat-icon>cloud_download</mat-icon>
											</button>
										</div>
									</mat-list-item>
								</ng-container>
							</mat-nav-list>
						</li>
					</ul>
					<ng-container *ngIf="group?.assets?.length > 0">
						<ul>
							<li *ngFor="let asset of group?.assets">
								<h5>{{asset?.onDemandAssetName}}</h5>
								<ul>
									<li *ngFor="let value of asset?.timeslots">
										<h5>{{moment.parseZone(value?.timeSlotDate).format('MM/DD/YYYY')}}</h5>
										<mat-nav-list>
											<ng-container *ngIf="value.documents?.length > 0">
												<mat-list-item (click)="showDocument(doc.documentId, doc.fileName)"
													*ngFor="let doc of value.documents"
													[class.selected]="isOpened && selectedDocumentDetails?.documentId === doc.documentId">
													<div matListAvatar *ngIf="!doc.thumbnailBase64; else imgThumbnail"
														[class]="getDocIcon(doc)"></div>
													<ng-template #imgThumbnail>
														<img class="image-thumbnail" [src]="getImageThumnail(doc)" />
													</ng-template>
	
													<h3 matLine>{{doc.fieldName}}</h3>
													<h3 matLine>{{doc.description}}</h3>
	
													<!-- <p matLine>
														<span style="text-align: right; float: right; color: lightgray;">
															{{moment.parseZone(doc.createdOn).format('MM/DD/YYYY')}} </span>
													</p> -->
	
													<div class="document-actions">
														<button mat-icon-button color="primary"
															(click)="downloadFile(doc.documentId, doc.fileName)"
															aria-label="Download document" title="Download">
															<mat-icon>cloud_download</mat-icon>
														</button>
													</div>
												</mat-list-item>
											</ng-container>
										</mat-nav-list>
									</li>
								</ul>
							</li>
						</ul>
					</ng-container>
				</li>
			</ul>
		</div>
	</mat-sidenav-content>
</mat-sidenav-container>